export default __webpack_public_path__ + "assets/images/time-icon-e2845536.svg";